module.exports = __webpack_public_path__ + "static/media/ordini3.df24b781.png";